export const IconNewUser = ({ size, color }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 18 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 19V17C17 14.7909 15.2091 13 13 13H5C2.79086 13 1 14.7909 1 17V19"
        stroke={color !== '' ? color : `white`}
        strokeWidth="1.58"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z"
        stroke={color !== '' ? color : `white`}
        strokeWidth="1.58"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </div>
)
